<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title text-truncate">{{'File Upload Manager' | translate }}</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="px-24 m-0" fusePerfectScrollbar>
        <input type="file" #file style="display: none" (change)="onFilesAdded()" [multiple]="options.multiple"
            [accept]="options.accept" />

        <!-- <mat-list>
            <mat-list-item *ngFor=" let file of files">
        <h4 mat-line>{{file.name}}</h4>
        <mat-progress-bar *ngIf="progress" mode="determinate" [value]="progress[file.name].progress | async">
        </mat-progress-bar>
        </mat-list-item>
        </mat-list> -->

        <table class="simple">
            <thead>
                <tr>
                    <th>{{'Name' | translate }}</th>
                    <th>{{'Progress' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let file of files">
                    <td>{{file.name}}</td>
                    <td>
                        <mat-progress-bar *ngIf="progress" mode="determinate"
                            [value]="progress[file.name].progress | async">
                        </mat-progress-bar>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row wrap" fxLayoutAlign="center center">
        <button [disabled]="uploading || uploadSuccessful" mat-raised-button color="primary" class="add-files-btn m-8"
            (click)="addFiles()">
            <mat-icon fxHide.gt-xs>add</mat-icon>
            <span *ngIf="options.multiple" fxHide.xs>{{'Add Files' | translate }}</span>
            <span *ngIf="!options.multiple" fxHide.xs>{{'Add file' | translate }}</span>
        </button>
        <span fxFlex fxHide.xs></span>
        <div *ngIf="!filesAdded && maxFileSizeLimit">{{'Max. file size: ' | translate}}{{maxFileSize}}</div>
        <div *ngIf="filesAdded" class="m-8">
            <button *ngIf="showCancelButton" mat-button mat-dialog-close>{{'Cancel' | translate }}</button>
            <button mat-raised-button color="primary" [disabled]="!canBeClosed" (click)="closeDialog()">
                {{primaryButtonText}}
            </button>
        </div>
    </div>
</div>